import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";


const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_KEY,
  authDomain: "apafrep.firebaseapp.com",
  projectId: "apafrep",
  storageBucket: "apafrep.appspot.com",
  messagingSenderId: "626145064230",
  appId: "1:626145064230:web:a409fbaa587b7f44e07de7",
  measurementId: "G-S6TE1GQRV5"
};

// const firebaseConfig = {
//   apiKey: "AIzaSyDjUdBmICKXWXFYUO1WzmKw_2h2FdMb0t4",
//   authDomain: "noubru-50e65.firebaseapp.com",
//   projectId: "noubru-50e65",
//   storageBucket: "noubru-50e65.appspot.com",
//   messagingSenderId: "237488909197",
//   appId: "1:237488909197:web:089aaa319b714faba7ebc4",
//   measurementId: "G-DRRZ4FRJ8S"
// };

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth();
export const storage = getStorage(app);